import React from 'react'
import { Field } from 'formik'
import { Flex } from '../../../ui/Layout'
import { H3 } from '../../../ui/Typography'
import Button from '../../../ui/Button'
import ModalContainer from '../../../ui/ModalContainer'
import { Input } from '../../../ui/Input'
import formikFormWrapper from '../../../formikFormWrapper.js'

const FormInput = formikFormWrapper(Input)

const WidgetNameModal = ({ isOpen, setIsOpen }) => {
  return (
    <ModalContainer interiorClose autoHeight p="24px" width="400px" isOpen={isOpen} setIsOpen={setIsOpen}>
      <H3 width="100%">Give your widget a name</H3>
      <Field mb="24px" maxLength={65} name="widget.name" label="Widget Name" dark component={FormInput} />
      <Flex justifyContent="flex-end">
        <Button onClick={() => setIsOpen(false)} variant="black" label="Next" />
      </Flex>
    </ModalContainer>
  )
}

export default WidgetNameModal
